export enum ApprovalRequestStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  REVISIT = 'REVISIT',
  EMPTY = '',
}
